import * as BABYLON from 'babylonjs';
const toRadians = value => BABYLON.Tools.ToRadians(value || 0);
export const orthoOptions = {
  orthoLeft: {
    alpha: 0,
    beta: toRadians(90)
  },
  orthoRight: {
    alpha: toRadians(180),
    beta: toRadians(90)
  },
  orthoFront: {
    alpha: toRadians(90),
    beta: toRadians(90)
  },
  orthoBack: {
    alpha: toRadians(270),
    beta: toRadians(90)
  },
  orthoTop: {
    alpha: toRadians(90),
    beta: 0
  },
  orthoBottom: {
    alpha: toRadians(90),
    beta: toRadians(180)
  }
};